<script setup>
  import Logo from "@components/Layout/Components/Logo.vue";
  import {MedLink} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "LayoutGuestHeader",
  });
</script>

<template>
  <header class="mx-auto flex w-full max-w-11xl place-items-center justify-between space-x-2 p-2 md:px-4">
    <div>
      <MedLink as="inertia" :href="$route('login')" data-test="guest-header-medicheck-logo-inertia-link">
        <Logo />
      </MedLink>
    </div>

    <div class="order-3 text-right">
      <div class="hidden text-xs text-gray-500 sm:block">MediCheck Service und Vertrieb</div>

      <MedLink href="https://www.pharma4u.de" target="_blank" data-test="guest-header-pharma4u-logo-link">
        <img class="sm:hidden" src="/resources/assets/images/pharma4u-icon-rgb.png" width="40" alt="" />
        <img class="hidden sm:inline-block" src="/resources/assets/images/pharma4u-logo-rgb.png" width="142" alt="" />
      </MedLink>
    </div>
  </header>
</template>
